import React, { Component } from "react";
import AntdProgress, {ProgressProps} from 'antd/lib/progress';
import 'antd/lib/progress/style';

export default class Progress extends Component<ProgressProps> {
    render() {
        return (
          <AntdProgress {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/progress/index.tsx